/**
 * A registry of LaunchDarkly feature flags
 *
 * When adding new LaunchDarkly flags, update this enum and the
 * corresponding `launchDarklyFlagDefaults` object.
 *
 * LaunchDarkly flags are identified by a single key across all environments
 * (targeting is managed server-side in the LaunchDarkly dashboard).
 */
export enum LaunchDarklyFlag {
    MAP_MARKER_IMPROVEMENTS = 'map-marker-improvements',
    MAX_NUMBER_OF_SUPPORTED_TASKS = 'max-number-of-supported-tasks',
    AURORA_AI = 'aurora-ai',
    DD_DRIVE_ENABLED = 'dd-drive-enabled',
    MULTI_CARRIER = 'multi-carrier',
    EV_BATTERY_REMAINING = 'ev-battery-remaining',
    CUSTOMER_NOTIFICATIONS = 'customer-notifications',
    OPTIMIZATION_SUGGESTIONS = 'optimization-suggestions',
    UNASSIGNED_TASKS_FOR_MULTIPLE_DAYS = 'unassigned-tasks-for-multiple-days'
}

/**
 * Default values for each LaunchDarkly flag
 *
 * These defaults are returned when the SDK has no value for the flag
 * (e.g. network failure, or the flag is not configured in the dashboard).
 * Local development resolves to the `stage` environment, so it receives
 * stage dashboard values rather than these defaults.
 *
 * Keep these in sync with the LaunchDarkly dashboard defaults.
 *
 * IMPORTANT!
 * + Flags not defined in this constant will not be exposed
 *   to the `useLaunchDarklyFlag()` hook, even if the flag is
 *   configured in the dashboard
 */
export const launchDarklyFlagDefaults: Record<LaunchDarklyFlag, unknown> = {
    [LaunchDarklyFlag.MAP_MARKER_IMPROVEMENTS]: false,
    [LaunchDarklyFlag.MAX_NUMBER_OF_SUPPORTED_TASKS]: 2000,
    [LaunchDarklyFlag.AURORA_AI]: false,
    [LaunchDarklyFlag.DD_DRIVE_ENABLED]: false,
    [LaunchDarklyFlag.MULTI_CARRIER]: false,
    [LaunchDarklyFlag.EV_BATTERY_REMAINING]: false,
    [LaunchDarklyFlag.CUSTOMER_NOTIFICATIONS]: false,
    [LaunchDarklyFlag.OPTIMIZATION_SUGGESTIONS]: false,
    [LaunchDarklyFlag.UNASSIGNED_TASKS_FOR_MULTIPLE_DAYS]: false
};
